import React from 'react'

export const IconBurger = props => (
  <svg viewBox='0 0 24 24' width='22' height='22' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <path d='M3 6h18M3 12h18M3 18h18' />
  </svg>
)

export const IconBack = props => (
  <svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
    <path d='M15 18l-6-6 6-6' />
  </svg>
)

export const IconPlus = props => (
  <svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <path d='M12 5v14M5 12h14' />
  </svg>
)

export const IconMinus = props => (
  <svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <path d='M5 12h14' />
  </svg>
)

export const IconSliders = props => (
  <svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <path d='M4 6h9M17 6h3M4 12h3M11 12h9M4 18h13M21 18h-1' />
    <circle cx='13' cy='6' r='2' />
    <circle cx='7' cy='12' r='2' />
    <circle cx='17' cy='18' r='2' />
  </svg>
)

export const IconStop = props => (
  <svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' strokeWidth='2' {...props}>
    <circle cx='12' cy='12' r='9' />
    <path d='M6 6l12 12' />
  </svg>
)

export const IconReturn = props => (
  <svg viewBox='0 0 24 24' width='20' height='20' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
    <path d='M12 19V5M6 11l6-6 6 6' />
  </svg>
)

export const IconClose = props => (
  <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <path d='M6 6l12 12M18 6L6 18' />
  </svg>
)

export const IconCheck = props => (
  <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
    <path d='M5 13l4 4L19 7' />
  </svg>
)

export const IconSearch = props => (
  <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' {...props}>
    <circle cx='11' cy='11' r='7' />
    <path d='M21 21l-4.3-4.3' />
  </svg>
)

export const IconTrash = props => (
  <svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
    <path d='M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6' />
  </svg>
)

export const IconChevron = props => (
  <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
    <path d='M6 9l6 6 6-6' />
  </svg>
)
